import React, { useState } from 'react';
import Navbar from '../../../components/navbar'
import Footer from '../../../components/footer';
import { FaPencilAlt, FaSearch, FaComments, FaCommentDots } from 'react-icons/fa'

export default function HomeEsp() {
  const [showAsk1, setShowAsk1] = useState(false)
  const [showAsk2, setShowAsk2] = useState(false)

  return (
    <div>
      <Navbar lang={'esp'} />
      <main className='flex mt-40 flex-col '>
        <section className='bg-danger mb-4 bg-opacity-15'>
          <p className='text-warning font-medium text-lg lg:w-4/6 md:w-5/6 w-11/12 m-auto p-4 text-center'> 
            Estimado(a) denunciante, le informamos que el Canal de Auditoría de Mig-PLUS se encuentra en fase de transición.
            Recomendamos que los nuevos registros se realicen directamente en la Línea Abierta de Ética (Ethics Open Line - EOL) de Cargill,
            a través del enlace <a href="https://cargill.navexone.com/intake/" target="_blank" rel="noopener noreferrer" className='font-bold '>https://cargill.navexone.com/intake/</a> o por teléfono <b>0800-000-2756</b>.
            En caso de dudas o dificultades de acceso al nuevo canal, comuníquese con el Comité de Ética de Mig-PLUS para obtener
            el apoyo correspondiente. ¡Atentamente!
          </p>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div className='gap-2 flex flex-col text-secondary font-medium'>
            <h1 className='text-primary flex items-center gap-4 text-2xl font-bold mb-8 uppercase'><FaComments size={`2.5rem`} />Defensor del pueblo</h1>
            <p>Bien venido</p>
            <p>Este es un canal exclusivo de Mig-PLUS para la comunicación segura de violaciones éticas, denuncias de irregularidades internas y externas, garantizando el anonimato del denunciante y la confidencialidad de los temas tratados.</p>
            <p>No se tolerarán represalias para aquellos que, de buena fe, denuncien cualquier violación de conducta.</p>
            <p>Al hacer uso de estos canales, tenga una actitud ética. ¡Ajá con responsabilidad!</p>
            <p><b>Consumidor:</b> para consultas, solicitudes, felicitaciones, sugerencias o reclamos sobre los productos, utilice nuestro <b>SAC: 0800-97-96876</b> or <b>+ 55 (54) 3347-3100</b>.</p>
          </div>
        </section>
        <section className='mt-12 mb-12 bg-background'>
          <div className='lg:w-4/6 md:w-5/6 w-11/12 m-auto p-8 flex flex-col'>
            <h2 className='text-center text-primary text-2xl font-bold'>Elija una de las siguientes opciones</h2>
            <div className='flex gap-8 justify-evenly mt-8 flex-col md:flex-row'>
              <span className='opacity-50 cursor-not-allowed bg-white px-16 py-8 border text-primary rounded-lg font-bold text-xl uppercase flex gap-4 select-none'>
                <FaPencilAlt size={'2rem'}/>
                hacer reporte
              </span>
              <a className='bg-white px-16 py-8 border text-primary shadow-xl rounded-lg font-bold text-xl hover:bg-primary hover:text-white uppercase flex gap-4' href="/es/consultar">
                <FaSearch size={'2rem'}/>
                seguir reporte
              </a>
            </div>
          </div>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div>
            <h1 className='text-4xl flex items-center gap-4 text-primary mb-8'><FaCommentDots/> Preguntas frecuentes</h1>
            <div className='rounded-md border border-background mb-8 shadow-md' >
              <button onClick={() => setShowAsk1(!showAsk1)} className='text-2xl bg-background w-full p-4 text-start text-secondary rounded-t-md'>¿Cómo funciona la Oidoría?</button>
              {showAsk1 &&
                <div className='m-4 flex flex-col gap-4 text-secondary font-medium text-lg'>
                  <p>La Oidoría funciona de la siguiente manera:</p>
                  <ul>
                    <li>Recibo;</li>
                    <li>Tratamiento;</li>
                    <li>Respuesta.</li>
                  </ul>
                  <p><b>Recibo: </b> el cliente envía el informe en nuestra web.</p>
                  <p><b>Tratamiento: </b> nuestro equipo evalúa y realiza las derivaciones necesarias respecto al reporte recibido de nuestro sitio web.</p>
                  <p><b>Respuesta: </b> el equipo envía una respuesta al cliente mediante el seguimiento de su informe en el sitio web.</p>
                </div>
              }
            </div>
            <div className='rounded-md border border-background mb-8 shadow-md'>
              <button onClick={() => setShowAsk2(!showAsk2)} className='text-2xl bg-background w-full p-4 text-start text-secondary rounded-t-md'>¿Cuándo me atenderán?</button>
              {
                showAsk2 &&
                <div className='m-4 flex flex-col gap-4 text-secondary font-medium text-lg'>
                  <p>El tiempo medio de respuesta al informe recibido es de 48 horas.</p>
                </div>
              }
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
};
